import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import moment from "moment";
import { filterParams } from "../../grid/GridHelpers";
import { links } from "src/app/types/orders/order";

export default function offSiteGridPlannedColumns(
    formatMessage: any
): Array<SimpleEntityGridColumn> {
    return [
        {
            field: "id",
            filter: "agSetColumnFilter",
            cellClass: "number-cell",
            minWidth: 60,
            maxWidth: 60,
            hide: true,
        },
        {
            field: "publishedAt",
            filter: "agDateColumnFilter",
            comparator: (date1, date2) => {
                const timeStamp1 = new Date(
                    moment(date1, "DD/MM/YYYY").format("YYYY-MM-DD")
                ).getTime();
                const timeStamp2 = new Date(
                    moment(date2, "DD/MM/YYYY").format("YYYY-MM-DD")
                ).getTime();
                return timeStamp1 - timeStamp2;
            },
            cellClassRules: {
                "order-fail": ({ data }: any) =>
                    moment(data.publishedAt).unix() <= moment().subtract(1, "d").unix(),
            },
            headerName: formatMessage({ id: "content.grid.col.publishedAt" }),
            valueGetter: ({ data }: any) => moment(data.publishedAt).format("DD/MM/YY"),
            filterParams,
            minWidth: 90,
            maxWidth: 90,
        },
        {
            field: "orderType",
            filter: "agSetColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.contentType" }),
            valueGetter: ({ data }: any) =>
                `${formatMessage({
                    id: `content.grid.col.orderType.${data.orderType}`,
                })} `,
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "contentType",
            filter: "agSetColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.contentType" }),
            valueGetter: ({ data }: any) =>
                `${formatMessage({
                    id: `content.grid.col.contentType.${data.contentType}`,
                })} ${formatMessage({
                    id: `content.grid.col.writingType.${data.writingType}`,
                })}`,
            minWidth: 100,
            maxWidth: 100,
        },
        {
            field: "wordCount",
            headerName: formatMessage({ id: "content.grid.col.wordCount" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 65,
            maxWidth: 65,
        },
        {
            field: "keywords",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.keyword" }),
            valueGetter: ({ data }: any) => {
                return data?.keywords;
            },
            cellRenderer: ({ data }: any) => (
                <div className="thematic-react-tag-wrapper gap-2 pb-2 pt-2">
                    {data?.keywords?.map((category: string, index: number) => (
                        <div key={index} className="thematic-react-tag">
                            {category}
                        </div>
                    ))}
                </div>
            ),
            minWidth: 300,
            maxWidth: 300,
        },
        {
            field: "links",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.links" }),
            valueGetter: ({ data }: any) =>
                data?.links
                    ? data.links[1]
                        ? `${data.links[0].url} (${data.links[0].anchor})\n ${data.links[1].url} (${data.links[1].anchor})`
                        : `${data.links[0].url} (${data.links[0].anchor})`
                    : "",

            cellRenderer: ({ data }: any) => (
                <ul className="padding-start-0 mb-0">
                    {data?.links?.map((link: links, index: number) => (
                        <li key={index} style={{ listStyleType: "none" }}>
                            {link.url} ({link.anchor})
                        </li>
                    ))}
                </ul>
            ),
        },
        {
            field: "keywords",
            autoHeight: true,
            headerName: formatMessage({ id: "content.grid.col.keyword" }),
            valueGetter: ({ data }: any) => {
                return data?.keywords;
            },
            cellRenderer: ({ data }: any) => (
                <div className="thematic-react-tag-wrapper gap-2 pb-2 pt-2">
                    {data?.keywords?.map((category: string, index: number) => (
                        <div key={index} className="thematic-react-tag">
                            {category}
                        </div>
                    ))}
                </div>
            ),
        },
        {
            field: "kd",
            headerName: formatMessage({ id: "content.grid.col.kd" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 65,
            maxWidth: 65,
        },
        {
            field: "volume",
            headerName: formatMessage({ id: "content.grid.col.volume" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 65,
            maxWidth: 65,
        },
    ];
}
